import axios from 'axios';
import { getStack } from '@/utils/stackUtils';

const stack = getStack();
const baseUrl = stack === 'local' ? 'http://localhost:5173' : import.meta.env.VITE_DATA_SERVER_URL;

export const getDatasets = async (query, page) => {
  const response = await axios.get(`${baseUrl}/api/data?${query}&page=${page}`, {
    withCredentials: true,
  });

  return response.data;
};

export const getDataset = async (query, datasetId) => {
  const response = await axios.get(`${baseUrl}/api/data?${query}&dataset_id=${datasetId}`, {
    withCredentials: true,
  });

  return response.data;
};

export const getMetadata = async () => {
  const response = await axios.get(`${baseUrl}/api/ecoinvent`, {
    withCredentials: true,
  });

  return response.data;
};
